import { uiRows } from './types-def.js';
/**
 * `web/undo` (2.L; CS r5b deliverable 165): the Undo toast offered after a write that names its
 * change batch. The brief's `undo.toast` is `undo.toast.offer` for the three-part id grammar.
 */
export const UNDO_INTERACTIONS = uiRows([
    {
        id: 'undo.toast.offer',
        module: 'web/undo',
        behavior: 'After an undoable write a toast offers a visible Undo button for ten seconds',
        owner: '2.L',
        since: 'exit-2b',
    },
]);
//# sourceMappingURL=undo.js.map